export var replaceCurrentUrl = function replaceCurrentUrl(url) {
  return window.history.replaceState({}, '', url);
};
//# sourceMappingURL=replaceCurrentUrl.js.map